import clsx from 'clsx';
import React from 'react';
import PropTypes from 'prop-types';
import { getClassSet, prefix, splitBsProps } from './utils/bootstrapUtils';
import { Size } from './utils/StyleConfig';
import { jsx as _jsx } from "react/jsx-runtime";
const ModalDialog = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    dialogClassName,
    className,
    style,
    children,
    onMouseDownDialog,
    bsClass = 'modal',
    bsSize,
    ...props
  } = _ref;
  const [bsProps, elementProps] = splitBsProps({
    ...props,
    bsClass,
    bsSize
  });
  const bsClassName = prefix(bsProps);
  const modalStyle = {
    display: 'block',
    ...style
  };
  const dialogClasses = {
    ...getClassSet(bsProps),
    [bsClassName]: false,
    [prefix(bsProps, 'dialog')]: true
  };
  return /*#__PURE__*/_jsx("div", {
    ...elementProps,
    ref: ref,
    tabIndex: "-1",
    role: "dialog",
    style: modalStyle,
    className: clsx(className, bsClassName),
    children: /*#__PURE__*/_jsx("div", {
      className: clsx(dialogClassName, dialogClasses),
      onMouseDown: onMouseDownDialog,
      children: /*#__PURE__*/_jsx("div", {
        className: prefix(bsProps, 'content'),
        role: "document",
        children: children
      })
    })
  });
});
ModalDialog.displayName = 'ModalDialog';
export default ModalDialog;